import { NavLink, useLocation } from 'react-router-dom'
import Button from '../Button'
import MenuHamburger from '../../assets/icons/Hamburger'
import { useState } from 'react'
import CloseIcon from '../../assets/icons/CloseIcon'
import ResieaseLogo from '../SafeltoLogo'
import DefaultButton from '../Button/Button'

interface NavBarLinksProps {
  className?: string
}

const NavBarLinks = ({
  className = 'hidden md:gap-8 sm:gap-5 items-baseline sm:flex',
}: NavBarLinksProps) => {
  const location = useLocation()

  const isActivePath = (path: string) => {
    return location.pathname === path ? 'text-black' : ''
  }

  return (
    <div className={className}>
      {/* <NavLink to='/' className={isActivePath('about')}>
      <p>About</p>
    </NavLink>
    <NavLink to='/' className={isActivePath('manage-estate')}>
      <p>Manage estate</p>
    </NavLink>
    <NavLink to='/auth/register' className={isActivePath('sign-up')}>
      <p>Register</p>
    </NavLink>
    <NavLink to='/log-in' className={isActivePath('log-in')}>
      <p>Sign in</p>
    </NavLink> */}
      <NavLink to="/waitlist" className={isActivePath('waitlist')}>
        <DefaultButton text="Join waitlist" />
      </NavLink>
      <NavLink to="/" className={isActivePath('contact')}>
        <Button text="Contact Us" />
      </NavLink>
    </div>
  )
}

const Navbar = () => {
  const [openMobileMenu, setOpenMobileMenu] = useState(false)

  const handleOpenMenuToggle = () => {
    setOpenMobileMenu(!openMobileMenu)
  }
  return (
    <nav className="fixed w-full md:h-20 sm:bg-white sm:h-20 bg-black">
      <div className="flex justify-between items-center sm:px-5 px-2 sm:pt-5 pt-2 sm:pb-6 pb-2 text-base text-gray-600">
        <ResieaseLogo theme="light" />
        <NavBarLinks />
        <div className="sm:hidden">
          <div className="border-solid border-2 rounded" onClick={handleOpenMenuToggle}>
            {openMobileMenu ? <CloseIcon /> : <MenuHamburger />}
          </div>
        </div>
      </div>
      <NavBarLinks
        className={
          openMobileMenu
            ? 'flex flex-col items-center gap-2 sm:hidden bg-white bg-opacity-80 py-4'
            : 'hidden'
        }
      />
    </nav>
  )
}

export default Navbar
